"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _ClickAwayListener = _interopRequireDefault(require("@eig-builder/core-ui/ClickAwayListener"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _portal = _interopRequireDefault(require("@eig-builder/core-utils/portal"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _wordpressHelper = require("@eig-builder/core-utils/helpers/wordpress-helper");

var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));

var _views = require("./views");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var popperModifiers = {
  preventOverflow: {
    enabled: true,
    boundariesElement: 'viewport'
  }
};
var popperOrigin = {
  transformOrigin: 'left top'
};

var SiteSelectorMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SiteSelectorMenu, _Component);

  var _super = _createSuper(SiteSelectorMenu);

  function SiteSelectorMenu() {
    var _this;

    (0, _classCallCheck2["default"])(this, SiteSelectorMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isMenuOpen: false,
      menuBtnRef: null
    };

    _this.onMenuClickAway = function (e) {
      e.currentTarget.activeElement !== _this.anchorEl && _this.setState({
        isMenuOpen: false
      });
    };

    _this.onMenuBtnClick = function (e) {
      _this.setState({
        isMenuOpen: !_this.state.isMenuOpen
      });
    };

    _this.onMenuItemBtnClick = function (e) {
      _this.setState({
        isMenuOpen: false
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(SiteSelectorMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isMobile = _this$props.isMobile,
          children = _this$props.children,
          currentSite = _this$props.currentSite,
          sites = _this$props.sites; // Do not render the site selector when we don't have a site

      if ((0, _isNil["default"])(currentSite)) {
        return null;
      }

      if (sites && sites.length === 1) {
        return null;
      } // Do not render when we are rendered inside WordPress


      if ((0, _wordpressHelper.checkIsWordpress)()) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_portal["default"], {
        elementId: "header-root"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _runtimeConfigHelper.getRuntimeConfig)()._app,
        style: {
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_views.MenuContainer, (0, _extends2["default"])({
        isMobile: isMobile,
        onClick: this.onMenuBtnClick,
        ref: function ref(node) {
          _this2.anchorEl = node;
        },
        "aria-owns": this.state.isMenuOpen ? 'navigation-site-selector-menu' : undefined,
        "aria-haspopup": "true"
      }, (0, _taggingHelper.getDataProperty)({
        dataElementLocation: _taggingHelper.DataElementLocations.NAV,
        dataElementLabel: 'navigation-site-selector-menu',
        dataElementId: "navigation-site-selector-menu",
        dataElementType: _taggingHelper.DataElementTypes.DROPDOWN
      })), /*#__PURE__*/_react["default"].createElement(_views.SiteThumbnail, {
        screenshot: currentSite.screenshot,
        className: "mr-3"
      }), /*#__PURE__*/_react["default"].createElement(_views.SiteName, {
        className: "mr-2"
      }, currentSite.name), this.state.isMenuOpen ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], null) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_views.StyledPopper, {
        isMobile: isMobile,
        open: this.state.isMenuOpen,
        anchorEl: this.anchorEl,
        placement: "bottom-start",
        modifiers: popperModifiers,
        transition: true
      }, function (_ref) {
        var TransitionProps = _ref.TransitionProps;
        return /*#__PURE__*/_react["default"].createElement(_Grow["default"], (0, _extends2["default"])({}, TransitionProps, {
          id: "navigation-site-selector-menu",
          style: popperOrigin
        }), /*#__PURE__*/_react["default"].createElement(_views.PopperContentContainer, null, /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
          onClickAway: _this2.onMenuClickAway
        }, /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.map(children, function (child) {
          return _react["default"].cloneElement(child, {
            onMenuItemBtnClick: _this2.onMenuItemBtnClick
          });
        })))));
      }))));
    }
  }]);
  return SiteSelectorMenu;
}(_react.Component);

SiteSelectorMenu.propTypes = {
  isMobile: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].node,
  currentSite: _propTypes["default"].object,
  sites: _propTypes["default"].array
};
var _default = SiteSelectorMenu;
exports["default"] = _default;